import { Tooltip, styled } from "@mui/material";

// export const TooltipCustom = styled(Tooltip)(({ theme }) => ({
//   // Cambiare il colore dello sfondo del tooltip
//   '& .MuiTooltip-tooltip': {
//     backgroundColor: theme.palette.primary.main, 
//     color: theme.palette.primary.contrastText, 
//   },
// }));

export const TooltipCustom = styled((props) => (
  <Tooltip arrow classes={{ popper: props.className, tooltip: 'custom-tooltip', arrow: 'custom-arrow' }} {...props} />
))(({ theme }) => ({
  '& .custom-tooltip': {
    backgroundColor: theme.palette.primary.main,
  },
  '& .custom-arrow::before': {
    backgroundColor: theme.palette.primary.main,
  },
}));

